import { render, staticRenderFns } from "./_ad.vue?vue&type=template&id=736bd186&scoped=true"
import script from "./_ad.vue?vue&type=script&lang=js"
export * from "./_ad.vue?vue&type=script&lang=js"
import style0 from "./_ad.vue?vue&type=style&index=0&id=736bd186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736bd186",
  null
  
)

export default component.exports